<template>
  <div>
    <vx-card :title="`Меню | Всего ${totalDishes}`" class="p-6">
      <vs-row class="mb-10">
        <vs-button
          :to="{ name: 'new-cafe-dish' }"
          class="rounded-full"
          color="primary"
          icon-pack="feather"
          icon="icon-plus-circle"
          type="filled"
          >Добавить блюдо</vs-button
        >
      </vs-row>
      <vs-row class="mb-5">
        <div class="header-filter md:w-1/6 w-full mb-5 mr-5 cursor-pointer">
          <v-select
            @input="getDishes()"
            :options="countItemsOmPage"
            :clearable="false"
            placeholder="Количество товаров"
            v-model="countElements"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>
      </vs-row>

      <template v-if="dishes">
        <vs-row class="-mx-4">
          <vs-col
            v-for="(item, index) in dishes"
            :key="index"
            class="w-full px-4 sm:w-6/12 lg:w-3/12 mb-base"
          >
            <router-link
              :to="{ path: `/cafe/dishes/${item.id}` }"
              class="text-black"
            >
              <vs-card actionable class="cardx pb-1">
                <div slot="media">
                  <img
                    v-if="item.image !== null"
                    :src="BASE_URL + item.image"
                    :alt="item.name"
                  />
                </div>
                <div>
                  <h4>{{ item.name }}</h4>
                  <p>
                    Цена:
                    <span class="text-primary">{{ item.price }} руб.</span>
                  </p>
                  <p>
                    Вес:
                    <span class="text-primary">{{ item.weight }} кг.</span>
                  </p>
                  <p>
                    Описание:
                    <span class="text-primary">{{ item.description }}</span>
                  </p>
                </div>
                <div slot="footer"></div>
              </vs-card>
            </router-link>
          </vs-col>
        </vs-row>

        <vs-pagination
          class="mt-4"
          :total="totalPagePagination"
          v-model="currentPagingationPage"
        ></vs-pagination>
      </template>
      <template v-else>
        <h5>В меню нет блюд</h5>
      </template>
    </vx-card>
  </div>
</template>
<script>
import { API_URL, countItemsOmPage } from "@/.env";

export default {
  data: () => ({
    BASE_URL: API_URL,
    dishes: [],

    filter: {},
    countElements: 20,
    currentPagingationPage: 1,
    totalDishes: 0,
    totalPagePagination: 1,
    countItemsOmPage,
  }),
  components: {},
  watch: {
    countElements: function () {
      this.currentPagingationPage = 1;
      this.getDishes();
    },
    currentPagingationPage: function () {
      this.getDishes();
    },
  },
  computed: {},
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    getDishes() {
      this.$vs.loading();

      this.filter.page =
        this.currentPagingationPage !== 1 ? this.currentPagingationPage : 1;
      this.filter.limit = this.countElements !== 20 ? this.countElements : 20;

      this.$load(async () => {
        let res = (await this.$api.cafe.getDishes(this.filter)).data;

        this.totalDishes = res.count;
        this.totalPagePagination = Math.ceil(
          this.totalDishes / this.countElements
        );

        this.dishes = res.results;
        this.$vs.loading.close();
      });
    },
  },
  created() {},
  mounted() {
    this.getDishes();
  },
};
</script>